// extracted by mini-css-extract-plugin
module.exports = {"content":"appointments__CreateAppointment__content"};